import axios from "axios";

import { MainUrl } from "../constants";

const API_URL = `${MainUrl}/schedule_chk`;

export const getSchedule = async (token, startDate, endDate) => {
  try {
    let bodyRequest = {
      start_date: startDate,
      end_date: endDate,
    };

    const response = await axios.post(`${API_URL}/grafic/`, bodyRequest, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    if (error.status == 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("access_level");
      window.location.href = "/";
    }
  }
};

export const GetScheduleDays = async (token, startDate, endDate) => {
  try {
    let bodyRequest = {
      start_date: startDate,
      end_date: endDate,
    };

    const response = await axios.post(`${API_URL}/days/`, bodyRequest, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    if (error.status == 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("access_level");
      window.location.href = "/";
    }
  }
};

export const GetScheduleAboutShifts = async (token, startDate, endDate) => {
  try {
    let bodyRequest = {
      start_date: startDate,
      end_date: endDate,
    };

    const response = await axios.post(`${API_URL}/about_shifts/`, bodyRequest, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    if (error.status == 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("access_level");
      window.location.href = "/";
    }
  }
};
